import React from 'react';
import { Button, Typography, Box, Grid, useMediaQuery } from '@mui/material';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import { styled } from '@mui/system';
import heroimg from '../images/Untitled design (6).png';

const Ripple = styled('span')(({ delay, isDesktop }) => ({
  position: 'absolute',
  borderRadius: '50%',
  width: isDesktop ? '100px' : '60px',
  height: isDesktop ? '100px' : '60px',
  backgroundColor: 'rgba(104, 77, 244, 0.2)',
  transform: 'translate(-50%, -50%)',
  animation: `heroripple 8s ${delay}s linear infinite`,
  '@keyframes heroripple': {
    '0%': {
      transform: 'translate(-50%, -50%) scale(0)',
      opacity: 0.5,
    },
    '100%': {
      transform: 'translate(-50%, -50%) scale(4)',
      opacity: 0,
    },
  },
}));

const MarketingService = () => {
  const ripples = [0, 1, 2, 3, 4];
  const isDesktop = useMediaQuery('(min-width:960px)');
  const isTablet = useMediaQuery('(min-width:600px) and (max-width:959px)');
  const isMobile = useMediaQuery('(max-width:599px)');

  return (
    <Box position="relative">
      <Grid container sx={{ py: 4, backgroundColor: '#f0f4ff' }}>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: isDesktop ? 'flex-start' : 'center',
            justifyContent: 'center',
            marginTop: isDesktop ? -3 : 4,
            position: 'relative',
            padding: { xs: 2, md: 9 },
          }}
        >
          <Box
            sx={{
              maxWidth: '80%',
              textAlign: isDesktop ? 'left' : 'center',
              zIndex: 1,
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, color: '#684df4', marginBottom: 1, fontSize: { xs: 15, md: 20 }, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}
            >
              Click. Convert. Grow
            </Typography>
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '28px', md: '48px' },
                fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                fontWeight: 600,
              }}
            >
              Your Digital Success Partner
            </Typography>
            <Typography variant="body1" color="textSecondary" paragraph sx={{ marginTop: 3, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", }}>
              At SN Info Systems, we bring your ideas to life with comprehensive UI/UX design, digital marketing, business analysis, and software solutions. From captivating user experiences to robust software, we've got you covered. Let us turn your concepts into impactful solutions and set your business on the path to success.
            </Typography>
            <Box sx={{ my: 4, display: 'flex', gap: 2 }}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: '#6C4BFE',
                  // mr: { md: 3 },
                  // mb: { xs: 1, md: 3 },
                  // mt: { md: 3 },
                  fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                  p: "10px 20px",
                  '&:hover': {
                    backgroundColor: '#552ffdff',
                    color: '#fff',
                    transition: 'all 0.3s ease-in-out',
                  }
                }}
              >
                ABOUT US
              </Button>
              <Button
                variant="outlined"
                sx={{
                  color: '#6C4BFE',
                  borderColor: '#6C4BFE',
                  fontWeight: 'bold',
                  padding: '10px 20px',
                  fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif",
                  '&:hover': {
                    backgroundColor: '#552ffdff',
                    color: '#fff',
                    borderColor: '#552ffdff',
                    transition: 'all 0.3s ease-in-out',
                  }
                }}
              >
                <PlayCircleFilledWhiteIcon sx={{ mr: 1, }} />
                Watch Our Story
              </Button>
            </Box>
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          <Box sx={{ position: 'relative', textAlign: 'center', width: '100%' }}>
            {ripples.map((_, index) => (
              <Ripple
                key={index}
                delay={index * 1}
                isDesktop={isDesktop}
                sx={{
                  marginTop: isDesktop ? '130px' : isTablet ? '100px' : '50px',
                  marginLeft: isDesktop ? '-710px' : isTablet ? '-500px' : '100%',
                }}
              />
            ))}
            <img
              src={heroimg}
              alt="heroimg"
              style={{
                maxWidth: '100%',
                height: 'auto',
                width: 'auto',
                marginBottom: isDesktop ? 0 : 2,
                zIndex: 2,
                transform: 'scale(0.9)',
                marginLeft: isDesktop ? '-150px' : isTablet ? '-100px' : 0,
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MarketingService;
